import {PropertyType} from 'common/report/constants';
import {DateRangeType} from 'common/widgets/date-range-picker/models/types';

import {BooleanOperator, FilterOperator, ListOperator, NumberOperator, ObjectOperator, StringOperator} from '../types';
import {ArithmeticOperator, Operator, TypeCastOperator} from './types';

export function getTypeCastOperatorFromType(type: PropertyType): TypeCastOperator {
  switch (type) {
    case PropertyType.Boolean:
      return TypeCastOperator.Boolean;
    case PropertyType.String:
      return TypeCastOperator.String;
    case PropertyType.Number:
      return TypeCastOperator.Number;
    case PropertyType.List:
      return TypeCastOperator.List;
    case PropertyType.Datetime:
      return TypeCastOperator.Datetime;
    default:
      throw new Error(`Invalid type ${type}`);
  }
}

export function getOperatorFromFilterOperator(filterOperator: FilterOperator): Operator {
  switch (filterOperator) {
    case ObjectOperator.Equals:
    case StringOperator.Equals:
    case NumberOperator.EqualTo:
    case DateRangeType.On:
    case BooleanOperator.True:
    case BooleanOperator.False:
      return ArithmeticOperator.Equals;
    case NumberOperator.NotEqualTo:
    case StringOperator.DoesNotEqual:
      return ArithmeticOperator.NotEquals;
    case NumberOperator.GreaterThan:
      return ArithmeticOperator.GreaterThan;
    case NumberOperator.LessThan:
      return ArithmeticOperator.LessThan;
    case NumberOperator.AtLeast:
      return ArithmeticOperator.GreaterThanEquals;
    case NumberOperator.AtMost:
      return ArithmeticOperator.LessThanEquals;
    case StringOperator.Contains:
    case ListOperator.Contains:
      return ArithmeticOperator.In;
    case ListOperator.DoesNotContain:
    case StringOperator.DoesNotContain:
      return ArithmeticOperator.NotIn;
    case ObjectOperator.Set:
    case StringOperator.Set:
      return ArithmeticOperator.Defined;
    case StringOperator.NotSet:
      return ArithmeticOperator.NotDefined;
    default:
      throw new Error(`Unsupported filter operator ${filterOperator}`);
  }
}
